<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2020-08-06 15:40:34
 * @Description: 配方卡片
-->
<template>
  <div :class="{ 'recipe-card': true, active: active }">
    <div class="name">
      <h3>
        #{{ this.recipe.hasOwnProperty("NoId") ? this.recipe.NoId : "?" }} -
        {{ this.recipe.name }}
      </h3>
      <span v-if="recipe.createdBy">{{ recipe.createdBy.name }}</span>
    </div>
    <div class="time">
      <div class="verify" :style="diffStyle">
        {{ statusToText(this.recipe.status) }}
      </div>
      <span>{{ formatedDate(this.recipe.createdAt) }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { formatedDate } from "@/utils";

export default {
  name: "RecipeCard",
  components: {},
  props: ["recipe", "active", "prodLogo", "recipeType"],
  data() {
    return {
      dayjs,
      formatedDate,
    };
  },
  computed: {
    diffStyle: function () {
      const style = { color: "black" };
      if (this.recipe.status === "verified" || this.recipe.status === "合格") {
        style.color = "#269F76";
      } else if (
        this.recipe.status === "rejected" ||
        this.recipe.status === "不合格"
      ) {
        style.color = "#D90013";
      } else if (
        this.recipe.status === "canceled" ||
        this.recipe.status === "弃用"
      ) {
        style.color = "#F1F3F4";
      } else {
        style.color = "#F0BB12";
      }
      return style;
    },
  },
  methods: {
    statusToText(status) {
      if (this.recipeType) {
        return "";
      } else {
        if (status === "verified" || status === "合格") {
          return "合格";
        } else if (status === "rejected" || status === "不合格") {
          return "不合格";
        } else if (status === "canceled" || status === "弃用") {
          return "弃用";
        } else {
          return "待审核";
        }
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.recipe-card
  width 100%
  height 70px
  padding 8px
  margin 8px 0
  border 1px solid lightgray
  border-radius 4px
  cursor pointer
  display flex
  justify-content space-between

  .time
    display flex
    flex-flow column
    justify-content space-around
    align-items flex-end

  .name
    display flex
    flex-flow column
    justify-content space-between

  &:hover
    color #0168fa
    border 1px solid #0168fa
    box-shadow 0 2px 4px rgba(209, 230, 250, 1)
    transition 0.2s

  span
    color darkgrey

.active
  color #0168fa
  border 1px solid #0168fa
  box-shadow 0 2px 4px rgba(209, 230, 250, 1)
  transition 0.2s
</style>
